import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function CompletedProfilesCard() {
  const [percent, setPercent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCompletedProfiles() {
      try {
        const snap = await getDocs(collection(db, "users"));

        let completed = 0;
        let total = snap.size;

        snap.forEach((doc) => {
          const data = doc.data();

          const hasPhoto = Array.isArray(data.avatarUrls) && data.avatarUrls.length > 0;
          const hasBio = typeof data.bio === "string" && data.bio.trim().length >= 3;
          const hasGender = data.gender && data.gender.trim().length > 0;
          const hasSearchGender =
            data.searchGender && data.searchGender.trim().length > 0;

          if (hasPhoto && hasBio && hasGender && hasSearchGender) {
            completed++;
          }
        });

        const result = total > 0 ? Math.round((completed / total) * 100) : 0;
        setPercent(result);
      } catch (error) {
        console.error("Erro ao calcular perfis completos:", error);
      } finally {
        setLoading(false);
      }
    }

    loadCompletedProfiles();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Perfis completos</p>

      <p className="metric-value">
        {loading || percent === null ? "..." : `${percent}%`}
      </p>

      <span className="metric-tag">Com foto, bio e preferências</span>
    </div>
  );
}
